import { styled } from '@mui/material/styles'

export const FlapComponent = styled('div')(({ theme }) => ({
	position: 'fixed',
	right: 0,
	top: '50%',
	width: '80px',
	height: '100px',
	backgroundColor: theme.palette.secondary.main,
	color: 'white',
	textAlign: 'center',
	lineHeight: '30px',
	cursor: 'pointer',
	transform: 'rotate(-90deg)',
	zIndex: 1001,
	marginRight: '-40px',

	'&:hover': {
		backgroundColor: '#0056b3',
	},
}))

export const sidebarStyles = (open: boolean) => ({
	overflowY: 'scroll',
	position: 'fixed',
	right: open ? 0 : '-500px',
	top: 0,
	width: '300px',
	height: '100%',
	backgroundColor: '#f4f4f4',
	// boxShadow: '-2px 0 5px rgba(0, 0, 0, 0.5)',
	padding: '20px',
	transition: 'right 0.3s ease',
	zIndex: 1000,
})

export const lastQuestionStyles = (isLast: boolean) => ({
	marginBottom: isLast ? '26px!important' : '',
})
